import dayjs from "dayjs";
import React, { useMemo } from "react";
import { InboxMessage } from "../../../network/types";
import { isEmpty } from "lodash";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { t } from "i18next";
import { onHandleNotification, defaultDispatchCb } from "../../../../../utils/notification-utils";

interface InboxItemProps {
  message: InboxMessage;
  highlightText?: string;
}

const highlightTextInContent = (text: string, highlight: string) => {
  if (!highlight) return text;

  const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = text.split(new RegExp(`(${escapedHighlight})`, "gi"));

  return parts.map((part, index) =>
    part.toLowerCase() === highlight.toLowerCase() ? (
      <span key={index} className="text-red-600">
        {part}
      </span>
    ) : (
      part
    ),
  );
};

export const InboxItem: React.FC<InboxItemProps> = ({ message, highlightText }) => {
  const { extendValue } = useMemo(() => {
    return message ?? {};
  }, [message]);
  if (!message) return null;

  return (
    <li
      key={message.id}
      className="p-4 bg-white border-b border-gray-100 cursor-pointer"
      onClick={() => {
        onHandleNotification({
          item: { id: message.id, extendValue: message.extendValue },
          dispatchCb: defaultDispatchCb,
        });
      }}
    >
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <p
            className="font-semibold text-[14px] leading-[22px] text-left"
            style={{ hyphens: "auto" }}
          >
            {highlightTextInContent(message.msgTitle, highlightText || "")}
            {!message.readStatus && (
              <span className="ml-2 inline-block w-2 h-2 bg-red-500 rounded-full"></span>
            )}
          </p>
        </div>
        <span className="text-[14px] font-medium leading-[20px] text-right text-gray-400 pl-4">
          {dayjs(message.time).format("DD/MM/YYYY HH:mm")}
        </span>
      </div>
      <p className="text-gray-600 py-2" style={{ whiteSpace: "pre-wrap" }}>
        {highlightTextInContent(message.msgContent, highlightText || "")}
      </p>
      {isEmpty(extendValue) ? null : (
        <div className="mt-2 text-cobalt flex flex-row items-center">
          {t("Common.view_detail")}
          <ChevronRightIcon style={{ marginLeft: -4 }} />
        </div>
      )}
    </li>
  );
};
